import { render, staticRenderFns } from "./ManagerTelsField.vue?vue&type=template&id=5fd37f8b&scoped=true"
import script from "./ManagerTelsField.vue?vue&type=script&lang=ts"
export * from "./ManagerTelsField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd37f8b",
  null
  
)

export default component.exports